import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsArray, IsString, IsUUID } from 'class-validator';
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { PromotionCartDto } from '../../external';
import { PromotionExposeGroup } from '../interface';
export class ValidatePromotionsDto {
}
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    IsUUID(4, { always: true, each: true }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", Array)
], ValidatePromotionsDto.prototype, "uuids", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ApiProperty({ type: () => PromotionCartDto }),
    __metadata("design:type", PromotionCartDto)
], ValidatePromotionsDto.prototype, "cart", void 0);
//# sourceMappingURL=ValidatePromotionsDto.js.map